import { createWebAuth } from '../auth0/Auth0Service';
import { getAuthCallbackUrl } from '../../config/ConfigService';
import { FLOW_PARAM } from 'ts/constants/UrlParams';
import { FlowType } from '../userflow/UserFlowService';

const authorizeFlow = (flow: FlowType, extraUrlParams?) => {
  createWebAuth(generateCallbackUrl(extraUrlParams)).authorize({
    [FLOW_PARAM]: flow,
    ...extraUrlParams,
  });
};

const generateCallbackUrl = (extraUrlParams?): string => {
  return extraUrlParams
    ? getAuthCallbackUrl() + '?' + new URLSearchParams(extraUrlParams).toString()
    : getAuthCallbackUrl();
};

export { authorizeFlow };
